import { defineComponent as _defineComponent } from 'vue'
import { getProductPrice } from '~/utils/ProductPrice';
import { generateVariantString } from '~/utils';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import AzImg from '~/components/Atoms/AzImg.vue';

import type { NormalizedProductVariantModels } from '~/types/models/product.models';
import type { PriceUnitModel } from '~/types/models/PriceDisplay.model';
import { useLocalization } from '~/composables/_next/useLocalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'AzPanelAddedToCartProductList',
  props: {
    products: null
  },
  setup(__props: any) {

const props = __props as {
  products: NormalizedProductVariantModels.Root[];
};



const { locale } = useLocalization();

/**
 * Gets the variant name.
 *
 * @param      {NormalizedProductVariantModels.Root}  product  The product
 * @return     {string}                               The variant name.
 */
function getVariantName(product: NormalizedProductVariantModels.Root): string {
  return generateVariantString(product, locale);
}

return { __sfc: true,props, locale, getVariantName, getProductPrice, PriceDisplay, AzImg }
}

})